import React from "react";
import { GridColDef } from "../../../Unknown/DataGrid";
import Typography from "../../../Unknown/Typography";
import {
  AppointmentAIReportColumnItemStudies,
  AppointmentAIReportRowItem,
} from "../types";
import Box from "../../../Unknown/Box";

type ColumnValue = string[];

export type ColumnStudiesTranslations = {
  columnStudies: string;
};

const getColumnStudies = (params: {
  columnItem: AppointmentAIReportColumnItemStudies;
  translations: ColumnStudiesTranslations;
}): GridColDef<AppointmentAIReportRowItem, ColumnValue> => {
  const { columnItem, translations } = params;

  return {
    field: columnItem.field,
    disableColumnMenu: true,
    flex: 1,
    headerName: translations.columnStudies,
    getApplyQuickFilterFn: () => null,
    valueGetter: (getterParams) => {
      return getterParams.row.studies;
    },
    renderCell: (renderParams) => {
      if (!renderParams.value || renderParams.value.length === 0) return null;

      return (
        <Box display="flex" flexDirection="column">
          {renderParams.value.map((study, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Typography variant="body2" key={`${study}-${index}`}>
              {study}
            </Typography>
          ))}
        </Box>
      );
    },
  };
};

export default getColumnStudies;
